// Berlin-timezone-aware "today" string in ISO date format (YYYY-MM-DD).
// Necessary because the backend uses Berlin time for daily lunch/dinner/variant
// lookups, while `new Date().toISOString()` yields UTC — this differs between
// 22:00-24:00 UTC (= 00:00-02:00 Berlin) and causes date-key mismatches.
export function getBerlinDate() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date());
  // 'en-CA' gives 'YYYY-MM-DD'
  return parts;
}
